import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';
import { source } from 'react-aim';

import { dispatch } from '@rematch/core';

import Roles from './CommunityFlow/Roles'
import Activities from './CommunityFlow/Activities'


import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';

@source({
    mouseEnter: (props, component) => dispatch.app.setHelpContext("Resource Pane")
})
class CommunityFlowResourcePane extends Component {

    constructor(props) {
        super(props);
        this.state = { activeIndex: null }
        this.editCommunity = this.editCommunity.bind(this);
    }
    editCommunity() {
        this.props.selectedPracticeFlowCommunity.packId = this.props.selectedPracticeLibrary._id;
        dispatch.createPack.editCommunityAsync(this.props.selectedPracticeFlowCommunity)
    }

    render() {
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        //let ifParentCommunity = this.props.parentCommunity && this.props.parentCommunity.length > 0 ?
        // <Accordion expandTool={expandTool} key='child' horizontal className="practiceFlowResourcePane" transitionDuration={this.props.transactionTime}>
        //     <div tabTitle="Role">
        //         <div className="acc-header">Role</div>
        //         <Roles name='Assign Role' {...this.props} selectedPracticeFlowCommunity={this.props.selectedPracticeFlowCommunity} parentCommunity={this.props.parentCommunity} status={this.props.selectedPracticeLibrary.status} />
        //     </div>
        //     <div tabProps={{ title: 'Assigned Activities' }}>
        //         <div className="acc-header">Assigned Activities</div>
        //         <Activities selectedPracticeFlowCommunity={this.props.selectedPracticeFlowCommunity}
        //             activityOptions={this.props.selectedPracticeLibrary.activities}
        //             communityActions={this.props.communityActions}
        //             status={this.props.selectedPracticeLibrary.status}
        //             editCommunity={this.editCommunity}
        //             {...this.props}
        //         />
        //     </div>
        // </Accordion>
        // :
        // <Accordion expandTool={expandTool} key='parent' horizontal className="practiceFlowResourcePane" transitionDuration={this.props.transactionTime}>
        //     <div tabTitle="Role">
        //         <div className="acc-header">Role</div>
        //         <Roles name='Assign Role'  {...this.props} selectedPracticeFlowCommunity={this.props.selectedPracticeFlowCommunity} parentCommunity={this.props.parentCommunity} status={this.props.selectedPracticeLibrary.status} />
        //     </div>
        // </Accordion>


        return (
            <div className="accordianBox w_100">
                <div className="accordianPanel w_100">
                    <Accordion
                        activeIndex={this.props.selectedPracticeFlowCommunity.parentCommunity ? this.state.activeIndex : 0}
                        onActivate={(activeIndex) => this.setState({ activeIndex })}
                        expandTool={expandTool}
                        key='child'
                        horizontal
                        className="practiceFlowResourcePane"
                        transitionDuration={this.props.transactionTime}
                        enableKeyboardNavigation={false}
                    >
                        {[
                            <div tabTitle="Group">
                                <div className="acc-header">{
                                    this.props.selectedPracticeFlowCommunity &&
                                        this.props.selectedPracticeFlowCommunity.parentCommunity
                                        ? "Sub Group" : "Group"}</div>
                                <Roles name='Role Details Card' {...this.props} selectedPracticeFlowCommunity={this.props.selectedPracticeFlowCommunity} parentCommunity={this.props.parentCommunity} status={this.props.selectedPracticeLibrary.status} />
                            </div>,
                            this.props.arrangementPaneActiveButtonFlag !== "Assign" && this.props.parentCommunity && this.props.parentCommunity.length > 0 ?
                                <div tabProps={{ title: 'Assigned Activities' }}>
                                    <div className="acc-header">Assigned Activities</div>
                                    <Activities selectedPracticeFlowCommunity={this.props.selectedPracticeFlowCommunity}
                                        activityOptions={this.props.selectedPracticeLibrary.activities}
                                        communityActions={this.props.communityActions}
                                        status={this.props.selectedPracticeLibrary.status}
                                        editCommunity={this.editCommunity}
                                        {...this.props}
                                    />
                                </div> : null

                        ].filter(elem => !!elem)}

                    </Accordion>
                </div>
            </div>
        )
    }
}

export default CommunityFlowResourcePane;